import { render, staticRenderFns } from "./TenderRequests.vue?vue&type=template&id=5deca406&scoped=true&"
import script from "./TenderRequests.vue?vue&type=script&lang=js&"
export * from "./TenderRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deca406",
  null
  
)

export default component.exports